export const videoActions = {
  LOADING: "LOADING",
  GET_VIDEOS_SUCCESS: "GET_VIDEOS_SUCCESS",
  ERROR: "ERROR",
};
